<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dialogues">
<div class="section level2" id="senor-and-chullo">
<h2>Senor and Chullo</h2>
<table style="width:98%;">
<colgroup>
<col width="4%"/>
<col width="80%"/>
</colgroup>
<thead>
<tr class="header">
<td align="left" colspan="2">S=Senor C=Chullo</td>
</tr>
</thead>
<tbody style="vertical-align: top;">
<tr class="odd">
<td align="left">S:</td>
<td>What a great day, Chullo!</td>
</tr>
<tr class="even">
<td align="left">C:</td>
<td>Yes, Senor.</td>
</tr>
<tr class="odd">
<td align="left">S:</td>
<td>Chullo, where are you?</td>
</tr>
<tr class="even">
<td align="left">C:</td>
<td>Here, Senor.</td>
</tr>
<tr class="odd">
<td align="left">S:</td>
<td>Where is here? I don’t see you.</td>
</tr>
<tr class="even">
<td align="left">C:</td>
<td>I am here.</td>
</tr>
<tr class="odd">
<td align="left">S:</td>
<td>I am getting unpleased.</td>
</tr>
<tr class="even">
<td align="left">C:</td>
<td>I am sorry, Senor.</td>
</tr>
<tr class="odd">
<td align="left">S:</td>
<td>Again I ask: Where is here?</td>
</tr>
<tr class="even">
<td align="left">C:</td>
<td>I am under your shoe, Senor.</td>
</tr>
<tr class="odd">
<td align="left">S:</td>
<td>How did you get there, Chullo?</td>
</tr>
<tr class="even">
<td align="left">C:</td>
<td>I was not looking where I was going and you were talking to the pretty senorita.</td>
</tr>
<tr class="odd">
<td align="left">S:</td>
<td>I thought I stepped on a piece of gum. You must look where you are going, Chullo.</td>
</tr>
<tr class="even">
<td align="left">C:</td>
<td>I have many sorrows, Senor.</td>
</tr>
<tr class="odd">
<td align="left">S:</td>
<td>You are forgiven. Now, pick yourself up and let us go.</td>
</tr>
<tr class="even">
<td align="left">C:</td>
<td>Yes, Senor.</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0009.vue?0a5d6742